const chanjet = [{
  desc: '获取登录地址',
  options: {
    url: '/Chanjet/getLoginUrl',
    method: 'post'
  }
}, {
  desc: '获取用户是否已注册过',
  options: {
    url: '/Chanjet/queryChanjetUser',
    method: 'get',
    argsParams: true
  },
  vuex: false
}, {
  desc: '获取用户是否已注册过',
  options: {
    url: '/Chanjet/queryAccountBookList',
    method: 'get',
    argsParams: true
  },
  vuex: false
}, {
  desc: '根据账套id获取科目信息',
  options: {
    url: '/Chanjet/queryGlaccountList',
    method: 'post'
  }
}, {
  desc: 'POST获取凭证文件地址',
  options: {
    url: '/Chanjet/QueryEntrypdf',
    method: 'post'
  }
}, {
  desc: '获取凭证类别',
  options: {
    url: '/Chanjet/queryGlCategory',
    method: 'post'
  }
}]
export default chanjet



// WEBPACK FOOTER //
// ./src/api/chanjet.js